import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import QuestionCircleIcon from '@atlaskit/icon/glyph/question-circle';
import { N500 } from '@atlaskit/theme/colors';
import { useDatasourceAnalyticsEvents } from '../../../../../analytics';
import { SEARCH_DEBOUNCE_MS } from '../constants';
import { asyncPopupSelectMessages } from './messages';
import CustomSelectMessage from './selectMessage';
var CustomNoOptionsMessage = function CustomNoOptionsMessage(_ref) {
  var filterName = _ref.filterName;
  var _useDatasourceAnalyti = useDatasourceAnalyticsEvents(),
    fireEvent = _useDatasourceAnalyti.fireEvent;

  /**
   * Debounce is required because our search is debounced
   * When we type in the input box, it does not trigger a request right away. This means, if you currently having an empty result set, and you do a search,
   * there might be some react render cycles becuause of setting search input value where you could seen an empty UI condition triggered.
   * To fix this, we need to wait till the search debounce period to see if the new results are emtpy or not.
   */
  var _useDebouncedCallback = useDebouncedCallback(function () {
      fireEvent('ui.emptyResult.shown.basicSearchDropdown', {
        filterName: filterName
      });
    }, SEARCH_DEBOUNCE_MS),
    _useDebouncedCallback2 = _slicedToArray(_useDebouncedCallback, 1),
    debouncedAnalyticsCallback = _useDebouncedCallback2[0];
  useEffect(debouncedAnalyticsCallback, [debouncedAnalyticsCallback]);
  return /*#__PURE__*/React.createElement(CustomSelectMessage
  // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19578
  , {
    icon: /*#__PURE__*/React.createElement(QuestionCircleIcon, {
      primaryColor: "var(--ds-icon, ".concat(N500, ")"),
      size: "xlarge",
      label: ""
    }),
    message: asyncPopupSelectMessages.noOptionsMessage,
    testId: "".concat(filterName, "--no-options-message")
  });
};
export default CustomNoOptionsMessage;